/**
 * Deep-links the brief to a field group by its stable id. We link by id, not a
 * step number, because a step's position is computed dynamically from the brief's
 * visible groups and is not stable. Resolved to `?step=` on load.
 */
export const GO_TO_GROUP_PARAM = 'goToGroup';

/** Route segment for the brief's review page (e.g. `.../brief/:jobId/review`). */
export const REVIEW_ROUTE_SEGMENT = 'review';

/** Field group containing the DesignLive appointment (day/time) question. */
export const APPOINTMENT_GROUP_ID = 'reviewingYourDesign';

/** 1-based step number for `groupId` in the ordered groups, or null if absent. */
export function stepIndexForGroup(
    orderedGroups: ReadonlyArray<{ id: string }>,
    groupId: string
): number | null {
    const index = orderedGroups.findIndex((group) => group.id === groupId);
    return index === -1 ? null : index + 1;
}
